// @ts-ignore This other file generated by Emscripten
import { useEffect, useState } from "react";
import DECtalkMini from "./dectalkMini";

// trans 🏳️‍⚧️ form
enum DECtalkTransformation {
  DEFAULT_11025 = "11025hz",
  DEFAULT_8000 = "8000hz",
  MOONBASE_ALPHA_44100 = "moonbase_alpha",
}

class DECtalk {
  private _Module: DECtalkMini;
  private _tts_init: () => number;
  private _tts_speak: (input: string, format: 0 | 1) => number;
  private _tts_get_buffer: () => number;
  private _tts_get_buffer_length: () => number;
  private _tts_reset: () => number;

  private toBytes(n: number) {
    return [0xff & n, 0xff & (n >> 8), 0xff & (n >> 16), 0xff & (n >> 24)];
  }

  private getSynthesisSampleRate(format: DECtalkTransformation) {
    switch (format) {
      case DECtalkTransformation.DEFAULT_11025:
      case DECtalkTransformation.MOONBASE_ALPHA_44100:
        return 11025;
      case DECtalkTransformation.DEFAULT_8000:
        return 8000;
      default:
        throw new Error("Unknown output format");
    }
  }

  private getOutputSampleRate(format: DECtalkTransformation) {
    switch (format) {
      case DECtalkTransformation.DEFAULT_11025:
        return 11025;
      case DECtalkTransformation.DEFAULT_8000:
        return 8000;
      case DECtalkTransformation.MOONBASE_ALPHA_44100:
        return 44100;
      default:
        throw new Error("Unknown output format");
    }
  }

  constructor(Module: DECtalkMini) {
    this._Module = Module;
    this._tts_init = Module.cwrap("tts_init", "number", []);
    this._tts_speak = Module.cwrap("tts_speak", "number", ["string", "number"]);
    this._tts_get_buffer = Module.cwrap("tts_get_buffer", "number", []);
    this._tts_get_buffer_length = Module.cwrap("tts_get_buffer_length", "number", []);
    this._tts_reset = Module.cwrap("tts_reset", "number", []);

    this._tts_init();
  }

  synthesize({ input, format }: { input: string; format: DECtalkTransformation }): Uint8Array<ArrayBuffer> {
    const synthesisSampleRate = this.getSynthesisSampleRate(format);
    const outputSampleRate = this.getOutputSampleRate(format);

    const result = this._tts_speak(input, synthesisSampleRate === 11025 ? 1 : 2);
    if (result !== 0) throw new Error("Synthesis error");

    const bufferPtr = this._tts_get_buffer();
    const bufferLen = this._tts_get_buffer_length();

    let samples = new Int16Array(this._Module.HEAP16.buffer, bufferPtr, bufferLen);
    if (format === DECtalkTransformation.MOONBASE_ALPHA_44100) samples = this.improveTheAudio(samples);

    const buffer = new Uint8Array(samples.buffer, samples.byteOffset, samples.byteLength);
    const bufferLength = 44 + buffer.length;

    // prettier-ignore
    const bytes = [
      0x52, 0x49, 0x46, 0x46,                // RIFF
      ...this.toBytes(bufferLength),         // WAV size
      0x57, 0x41, 0x56, 0x45,                // WAVE
      0x66, 0x6d, 0x74, 0x20,                // fmt
      0x10, 0x00, 0x00, 0x00,                // fmt chunk size
      0x01, 0x00, 0x01, 0x00,                // Audio format 1=PCM & Number of channels 1=Mono
      ...this.toBytes(outputSampleRate),     // Sampling Frequency in Hz
      ...this.toBytes(outputSampleRate * 2), // bytes per second
      0x02, 0x00, 0x10, 0x00,                // 2=16-bit mono & Number of bits per sample
      0x64, 0x61, 0x74, 0x61,                // data
      ...this.toBytes(buffer.length)         // data size
    ]

    const arr = new Uint8Array([...bytes, ...buffer]);
    return arr;
  }

  /**
   * Convert a normal buffer into Moonbase Alpha
   * @param i16 int16 buffer
   * @returns Moonbase Alpha-ified audio
   */
  private improveTheAudio(i16: Int16Array) {
    const factor = 4;
    if (!i16.length) return new Int16Array(0);

    const out = new Float32Array((i16.length - 1) * factor + 1);
    for (let i = 0; i < i16.length - 1; i++) {
      const a = i16[i] / 32768;
      const base = i * factor;
      for (let j = 0; j < factor; j++) out[base + j] = a;
    }
    out[out.length - 1] = i16[i16.length - 1] / 32768;

    return Int16Array.from(out, x => x * 32768);
  }
}

const useDectalk = () => {
  const [dectalk, setDectalk] = useState<DECtalk | null>(null);

  useEffect(() => {
    const init = async () => {
      const Module = await DECtalkMini();
      const dectalk = new DECtalk(Module);
      setDectalk(dectalk);
    };

    init();
  }, []);

  return { dectalk };
};

export { DECtalkTransformation, useDectalk };

// let Module = null;
// let tts_init, tts_speak, tts_get_buffer, tts_get_buffer_length, tts_reset;
// let audioContext = null;
// let currentSource = null;
// let currentAudioBuffer = null;
// let currentSampleRate = 11025;
// let phonemeTimeline = [];
// let playbackStartTime = 0;
// let animationFrameId = null;
// let preloadedImages = {};

// const textInput = document.getElementById("text-input");
// const sampleRateSelect = document.getElementById("sample-rate");
// const btnSpeak = document.getElementById("btn-speak");
// const btnStop = document.getElementById("btn-stop");
// const btnDownload = document.getElementById("btn-download");
// const btnExportGif = document.getElementById("btn-export-gif");
// const lastPhoneDisplay = document.getElementById("last-phone-display");
// const mouthImage = document.getElementById("mouth-image");

// const phonemes = [
//   "SIL",
//   "IY",
//   "IH",
//   "EY",
//   "EH",
//   "AE",
//   "AA",
//   "AY",
//   "AW",
//   "AH",
//   "AO",
//   "OW",
//   "OY",
//   "UH",
//   "UW",
//   "RR",
//   "YU",
//   "AX",
//   "IX",
//   "IR",
//   "ER",
//   "AR",
//   "OR",
//   "UR",
//   "W",
//   "Y",
//   "R",
//   "LL",
//   "HX",
//   "RX",
//   "LX",
//   "M",
//   "N",
//   "NX",
//   "EL",
//   "D_DENTALIZED",
//   "EN",
//   "F",
//   "V",
//   "TH",
//   "DH",
//   "S",
//   "Z",
//   "SH",
//   "ZH",
//   "P",
//   "B",
//   "T",
//   "D",
//   "K",
//   "G",
//   "DX",
//   "TX",
//   "Q",
//   "CH",
//   "JH",
//   "DF",
// ];

// const imageMap = {
//   SIL: "sil.svg",
//   IY: "ax_i_ii.svg",
//   IH: "ax_i_ii.svg",
//   EY: "ei.svg",
//   EH: "e.svg",
//   AE: "ax_i_ii.svg",
//   AA: "a_aa_uh.svg",
//   AY: "a_aa_uh.svg",
//   AW: "a_aa_uh.svg",
//   AH: "a_aa_uh.svg",
//   AO: "o.svg",
//   OW: "o.svg",
//   OY: "ei.svg",
//   UH: "a_aa_uh.svg",
//   UW: "o.svg",
//   RR: "n_k_g_ng_y_r.svg",
//   YU: "o.svg",
//   AX: "ax_i_ii.svg",
//   IX: "ax_i_ii.svg",
//   IR: "n_k_g_ng_y_r.svg",
//   ER: "n_k_g_ng_y_r.svg",
//   AR: "n_k_g_ng_y_r.svg",
//   OR: "n_k_g_ng_y_r.svg",
//   UR: "n_k_g_ng_y_r.svg",
//   W: "w_oo_uu_u.svg",
//   Y: "n_k_g_ng_y_r.svg",
//   R: "n_k_g_ng_y_r.svg",
//   LL: "l.svg",
//   HX: "ax_i_ii.svg",
//   RX: "n_k_g_ng_y_r.svg",
//   LX: "l.svg",
//   M: "p_b_m.svg",
//   N: "n_k_g_ng_y_r.svg",
//   NX: "n_k_g_ng_y_r.svg",
//   EL: "l.svg",
//   D_DENTALIZED: "t_d_s_z.svg",
//   EN: "n_k_g_ng_y_r.svg",
//   F: "f_v.svg",
//   V: "f_v.svg",
//   TH: "th_dh.svg",
//   DH: "th_dh.svg",
//   S: "t_d_s_z.svg",
//   Z: "t_d_s_z.svg",
//   SH: "sh_zh_ch_jh.svg",
//   ZH: "sh_zh_ch_jh.svg",
//   P: "p_b_m.svg",
//   B: "p_b_m.svg",
//   T: "t_d_s_z.svg",
//   D: "t_d_s_z.svg",
//   K: "n_k_g_ng_y_r.svg",
//   G: "n_k_g_ng_y_r.svg",
//   DX: "t_d_s_z.svg",
//   TX: "t_d_s_z.svg",
//   Q: "e.svg",
//   CH: "sh_zh_ch_jh.svg",
//   JH: "sh_zh_ch_jh.svg",
//   DF: "t_d_s_z.svg",
// };

// function preloadImages() {
//   const uniqueImages = [...new Set(Object.values(imageMap))];
//   uniqueImages.forEach(filename => {
//     const img = new Image();
//     img.onload = () => {
//       preloadedImages[filename] = img;
//       if (filename === "sil.svg") {
//         mouthImage.src = img.src;
//       }
//     };
//     img.src = "/img/" + filename;
//   });
// }

// window.onPhoneCallback = function (phoneme) {
//   // Use buffer position BEFORE adding new samples for accurate timing
//   const samplePosition = tts_get_buffer_length();
//   const timeInSeconds = samplePosition / currentSampleRate;
//   const phonemeName = phonemes[phoneme] || "UNKNOWN";

//   // Only add if phoneme changed
//   if (phonemeTimeline.length === 0 || phonemeTimeline[phonemeTimeline.length - 1].phone !== phoneme) {
//     phonemeTimeline.push({
//       phone: phoneme,
//       phonemeName: phonemeName,
//       time: timeInSeconds,
//       sample: samplePosition,
//     });
//   }
// };

// async function loadWASM() {
//   try {
//     if (typeof DECtalkMini === "undefined") {
//       await new Promise((resolve, reject) => {
//         const script = document.createElement("script");
//         script.src = "./DECtalkMini.js";
//         script.onload = resolve;
//         script.onerror = reject;
//         document.head.appendChild(script);
//       });
//     }

//     Module = await DECtalkMini();
//     tts_init = Module.cwrap("tts_init", "number", []);
//     tts_speak = Module.cwrap("tts_speak", "number", ["string", "number"]);
//     tts_get_buffer = Module.cwrap("tts_get_buffer", "number", []);
//     tts_get_buffer_length = Module.cwrap("tts_get_buffer_length", "number", []);
//     tts_reset = Module.cwrap("tts_reset", "number", []);

//     tts_init();
//     audioContext = new (window.AudioContext || window.webkitAudioContext)();
//     btnSpeak.disabled = false;
//   } catch (err) {
//     alert("Failed to load WASM module: " + err.message);
//   }
// }

// function synthesize() {
//   try {
//     phonemeTimeline = [];
//     const text = textInput.value.trim();
//     if (!text) {
//       alert("Please enter some text");
//       return null;
//     }

//     const format = parseInt(sampleRateSelect.value);
//     currentSampleRate = format === 0x0001 ? 11025 : 8000;

//     const result = tts_speak(text, format);
//     if (result !== 0) {
//       alert("TTS error code: " + result);
//       return null;
//     }

//     const bufferPtr = tts_get_buffer();
//     const length = tts_get_buffer_length();

//     if (length === 0) {
//       alert("No audio data generated");
//       return null;
//     }

//     const samples = new Int16Array(Module.HEAP16.buffer, bufferPtr, length);
//     const samplesCopy = new Int16Array(samples);

//     const audioBuffer = audioContext.createBuffer(1, length, currentSampleRate);
//     const channelData = audioBuffer.getChannelData(0);

//     for (let i = 0; i < length; i++) {
//       channelData[i] = samplesCopy[i] / 32768.0;
//     }

//     return audioBuffer;
//   } catch (err) {
//     alert("Synthesis error: " + err.message);
//     return null;
//   }
// }

// function playAudio(audioBuffer) {
//   stopAudio();

//   currentSource = audioContext.createBufferSource();
//   currentSource.buffer = audioBuffer;
//   currentSource.connect(audioContext.destination);

//   playbackStartTime = audioContext.currentTime;

//   currentSource.onended = function () {
//     btnStop.disabled = true;
//     if (animationFrameId) {
//       cancelAnimationFrame(animationFrameId);
//       animationFrameId = null;
//     }
//   };

//   currentSource.start();
//   btnStop.disabled = false;
//   updatePhonemeDisplay();
// }

// function updatePhonemeDisplay() {
//   if (!currentSource) return;

//   const currentTime = audioContext.currentTime - playbackStartTime;
//   let currentPhoneme = "";

//   for (let i = 0; i < phonemeTimeline.length; i++) {
//     if (phonemeTimeline[i].time <= currentTime) {
//       currentPhoneme = phonemeTimeline[i].phonemeName;
//     } else {
//       break;
//     }
//   }

//   lastPhoneDisplay.value = currentPhoneme;

//   if (currentPhoneme && imageMap[currentPhoneme] && preloadedImages[imageMap[currentPhoneme]]) {
//     mouthImage.src = preloadedImages[imageMap[currentPhoneme]].src;
//   }

//   animationFrameId = requestAnimationFrame(updatePhonemeDisplay);
// }

// function stopAudio() {
//   if (currentSource) {
//     try {
//       currentSource.stop();
//     } catch (e) {}
//     currentSource = null;
//   }
//   if (animationFrameId) {
//     cancelAnimationFrame(animationFrameId);
//     animationFrameId = null;
//   }
//   btnStop.disabled = true;
// }

// function audioBufferToWav(buffer) {
//   const numChannels = 1;
//   const sampleRate = buffer.sampleRate;
//   const data = buffer.getChannelData(0);
//   const dataLength = data.length * 2;
//   const bufferLength = 44 + dataLength;

//   const arrayBuffer = new ArrayBuffer(bufferLength);
//   const view = new DataView(arrayBuffer);

//   const writeString = function (offset, string) {
//     for (let i = 0; i < string.length; i++) {
//       view.setUint8(offset + i, string.charCodeAt(i));
//     }
//   };

//   writeString(0, "RIFF");
//   view.setUint32(4, bufferLength - 8, true);
//   writeString(8, "WAVE");
//   writeString(12, "fmt ");
//   view.setUint32(16, 16, true);
//   view.setUint16(20, 1, true);
//   view.setUint16(22, numChannels, true);
//   view.setUint32(24, sampleRate, true);
//   view.setUint32(28, sampleRate * 2, true);
//   view.setUint16(32, 2, true);
//   view.setUint16(34, 16, true);
//   writeString(36, "data");
//   view.setUint32(40, dataLength, true);

//   let offset = 44;
//   for (let i = 0; i < data.length; i++) {
//     const sample = Math.max(-1, Math.min(1, data[i]));
//     view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true);
//     offset += 2;
//   }

//   return arrayBuffer;
// }

// btnSpeak.addEventListener("click", function () {
//   const audioBuffer = synthesize();
//   if (audioBuffer) {
//     currentAudioBuffer = audioBuffer;
//     playAudio(audioBuffer);
//     btnDownload.disabled = false;
//     btnExportGif.disabled = false;
//   }
// });

// btnStop.addEventListener("click", stopAudio);

// btnDownload.addEventListener("click", function () {
//   if (!currentAudioBuffer) return;

//   const wav = audioBufferToWav(currentAudioBuffer);
//   const blob = new Blob([wav], { type: "audio/wav" });
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = "output.wav";
//   a.click();
//   URL.revokeObjectURL(url);
// });

// btnExportGif.addEventListener("click", async function () {
//   if (!currentAudioBuffer || phonemeTimeline.length === 0) return;

//   try {
//     btnExportGif.disabled = true;
//     btnExportGif.textContent = "Loading...";

//     // Load GIF.js library dynamically
//     if (typeof GIF === "undefined") {
//       await new Promise(function (resolve, reject) {
//         const script = document.createElement("script");
//         script.src = "./gif.js";
//         script.onload = resolve;
//         script.onerror = function () {
//           reject(new Error("Failed to load GIF.js library"));
//         };
//         document.head.appendChild(script);
//       });
//     }

//     const canvas = document.createElement("canvas");
//     canvas.width = 400;
//     canvas.height = 400;
//     const ctx = canvas.getContext("2d");

//     const gif = new GIF({
//       workers: 2,
//       quality: 10,
//       width: canvas.width,
//       height: canvas.height,
//       workerScript: "./gif.worker.js",
//     });

//     const duration = currentAudioBuffer.length / currentAudioBuffer.sampleRate;

//     btnExportGif.textContent = "Rendering...";

//     console.log("Audio length:", currentAudioBuffer.length, "samples at", currentAudioBuffer.sampleRate, "Hz");
//     console.log("Duration:", duration, "seconds");
//     console.log("Phoneme timeline entries:", phonemeTimeline.length);
//     console.log("First phoneme:", phonemeTimeline[0]);
//     console.log("Last phoneme:", phonemeTimeline[phonemeTimeline.length - 1]);

//     // One frame per phoneme with exact duration
//     for (let i = 0; i < phonemeTimeline.length; i++) {
//       const currentPhoneme = phonemeTimeline[i].phonemeName;
//       const currentTime = phonemeTimeline[i].time;
//       const nextTime = i < phonemeTimeline.length - 1 ? phonemeTimeline[i + 1].time : duration;
//       const phonemeDurationMs = Math.round((nextTime - currentTime) * 1000);

//       ctx.fillStyle = "#ffffff";
//       ctx.fillRect(0, 0, canvas.width, canvas.height);

//       const imageName = imageMap[currentPhoneme];
//       if (imageName && preloadedImages[imageName]) {
//         const img = preloadedImages[imageName];
//         const imgSize = 300;
//         const x = (canvas.width - imgSize) / 2;
//         const y = (canvas.height - imgSize) / 2;
//         ctx.drawImage(img, x, y, imgSize, imgSize);
//       }

//       ctx.fillStyle = "#000000";
//       ctx.font = "bold 32px monospace";
//       ctx.textAlign = "center";
//       ctx.fillText(currentPhoneme, canvas.width / 2, canvas.height - 30);

//       gif.addFrame(ctx, { copy: true, delay: phonemeDurationMs });
//     }

//     // Add 1 second of padding frames (30 frames at 33ms each)
//     const lastPhoneme = phonemeTimeline[phonemeTimeline.length - 1].phonemeName;
//     const lastImageName = imageMap[lastPhoneme];

//     for (let pad = 0; pad < 30; pad++) {
//       ctx.fillStyle = "#ffffff";
//       ctx.fillRect(0, 0, canvas.width, canvas.height);

//       if (lastImageName && preloadedImages[lastImageName]) {
//         const img = preloadedImages[lastImageName];
//         const imgSize = 300;
//         const x = (canvas.width - imgSize) / 2;
//         const y = (canvas.height - imgSize) / 2;
//         ctx.drawImage(img, x, y, imgSize, imgSize);
//       }

//       ctx.fillStyle = "#000000";
//       ctx.font = "bold 32px monospace";
//       ctx.textAlign = "center";
//       ctx.fillText(lastPhoneme, canvas.width / 2, canvas.height - 30);

//       gif.addFrame(ctx, { copy: true, delay: 33 });
//     }

//     btnExportGif.textContent = "Encoding...";

//     gif.on("finished", function (blob) {
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = "dectalk_animation.gif";
//       a.click();
//       URL.revokeObjectURL(url);

//       btnExportGif.disabled = false;
//       btnExportGif.textContent = "Export GIF";
//     });

//     gif.on("progress", function (progress) {
//       const percent = Math.round(progress * 100);
//       btnExportGif.textContent = "Encoding " + percent + "%";
//     });

//     gif.render();
//   } catch (err) {
//     alert("GIF export error: " + err.message);
//     btnExportGif.disabled = false;
//     btnExportGif.textContent = "Export GIF";
//   }
// });

// preloadImages();
// loadWASM();
